import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { themePalette } from '../../../../../components/ThemeProvider/themeColors';

interface ApplicationCardProps {
  orderCount: number;
  requestDate: string;
  onViewStatuses: () => void;
}

const ApplicationCard = ({ orderCount, requestDate, onViewStatuses }: ApplicationCardProps) => {
  const { t } = useTranslation('salary-card');

  return (
    <CardContainer>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography fontSize={18} fontWeight={600} lineHeight='28px'>
          {t('newApplicationContent.product.title')}
        </Typography>
        <Box sx={{ display: 'flex', gap: { xs: 2, md: 8 }, mt: 1, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              fontSize={13}
              color={themePalette.text_and_icon.third_party}
              lineHeight='18px'
            >
              {t('applicationsPage.employeesCardsCount')}
            </Typography>
            <Typography fontSize={14} fontWeight={600} lineHeight='20px'>
              {t('applicationsPage.employeesCardsCountValue', { count: orderCount })}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              fontSize={13}
              color={themePalette.text_and_icon.third_party}
              lineHeight='18px'
            >
              {t('applicationsPage.requestDate')}
            </Typography>
            <Typography fontSize={14} fontWeight={600} lineHeight='20px'>
              {requestDate}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{ display: 'flex', gap: 1.5, alignItems: 'center', width: { xs: '100%', sm: 'auto' } }}
      >
        <Button onClick={onViewStatuses}>{t('applicationsPage.viewStatuses')}</Button>
      </Box>
    </CardContainer>
  );
};

const CardContainer = styled('div')({
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '24px 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  '@media (max-width: 900px)': {
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

export default ApplicationCard;
